<template>
  <div>
      <el-button style="position: absolute;float: right;right: 35px;top: 6px;" 
        type="primary" plain size="small" @click="bak">
        返回
      </el-button>
    <section>
      <!--工具条-->
      <!-- <el-col :span="24" class="toolbar" style="padding-bottom: 0px;border:1px solid #dfe6ec;">
        <el-form :inline="true"  @submit.native.prevent>
          <el-form-item label="订单账户:" >
            <el-input readonly="readonly" v-model="checkUser"  style="width:300px;"></el-input>
          </el-form-item>
        </el-form>
      </el-col> -->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;border:1px solid #dfe6ec;">
        <el-form :inline="true"  @submit.native.prevent>
          <el-form-item > 
            <el-input readonly="readonly" v-model="userType"  style="width:120px;"></el-input>
					</el-form-item>
          <el-form-item  >
            <el-input v-if="person == '2'" readonly="readonly" v-model="checkPerson" placeholder="企业用户" style="width:300px;"></el-input>
            <el-input v-else readonly="readonly" v-model="checkUser" placeholder="个人用户" style="width:350px;"></el-input>
          </el-form-item>
        </el-form>
      </el-col>

      <div>
        <el-table tooltip-effect="dark" :data="proList3" highlight-current-row v-loading="listLoading"
          style="width: 100%;" class="aaaaa">
          <el-table-column type="index" :index="indexMethod" label="序号" width="100">
          </el-table-column>
          <el-table-column prop="logo2" header-align="center" align="center" min-width="220px" label="图片">
            <template slot-scope="scope">
              <img slot="reference" :src="scope.row.logo2" :alt="scope.row.logo2" class="tpimg">
            </template>
          </el-table-column>
          <el-table-column prop="name" label="产品名称" min-width="220" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="purchaseMonth" label="购买时长(月)" width="220" >
              <template slot-scope="{row,$index}">
                  <el-input  type="number" min='1' disabled class="input_Border"  
                    v-model="row.purchaseMonth">
                  </el-input>
              </template>
          </el-table-column>
          <el-table-column prop="purchaseNum" label="购买数量" width="210" >
              <template slot-scope="{row,$index}">
                  <el-input  type="number" min='1' disabled class="input_Border" 
                    v-model="row.purchaseNum">
                  </el-input>
              </template>
          </el-table-column>
          <el-table-column prop="price2" label="单价(元)" min-width="200" show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </div>
      <!-- 订单提交栏 -->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;border:1px solid #dfe6ec;">
        <el-form :inline="true"  @submit.native.prevent >
          <el-checkbox-group v-model="checkList" class="order-checkbox">
            <el-checkbox label="试用订单" disabled ></el-checkbox>
          </el-checkbox-group></br>
          <el-form-item label="总价:" class="allPrice">
            <el-input  v-model="allPrice" class="price" readonly="readonly" :disabled="disCheckBox" style="width:120px;"></el-input>
          </el-form-item>
          <!-- <el-form-item label="预估价格:" class="ygPrice">
            {{ygPrice}} 元
          </el-form-item></br> -->
        </el-form>
      </el-col>

    </section>		
    <div class="ftBox">
      <div class="ft">
        <p>CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906</p>
      </div>
    </div>
  </div>
</template>
<script>
import { API__code, API_User ,API_Product,imgURLs, API_Order} from '../../../api/index.js'
export default {
  data(){
    return {
      proList3:[],
      userType:'',
      checkPerson:'',

      person:'',

      proType:'',
      disCheckBox:false,
      ygPrice:0,//预估价格
      allPrice:0,//总价
      checkList:[],
      proList:[],
      proList2:[],
      listLoading:false,
      token:'',
      checkCode:"",
      id:"",
      isDisabled:true,

      orderVisible:false,
      orderLoading:false,

      userLoading:false,
      pageNumber2:1,
      pageSize2:10,
      total2:0,
      souchs2:{
        modelName:'',
      },
      users:[],
      checkUser:'',
      checkUser2:'',
      checkUserId:'',
      pruductJson:[],
      
    }
  },
  methods:{
    indexMethod(index) {
      return (index+1);
    },
    getProList:function(){
      let _this = this;
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        listType:'page',
        pageNumber:'1',
        pageSize:'9999',
        useful: '1',
        purchasable: '0'
      }
      this.listLoading = true;
      API_Product.productList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.total = res.data.data.totalRow;
          for(var i=0;i<res.data.data.list.length;i++){
            if(res.data.data.list[i].purchasable){
              if(res.data.data.list[i].purchasable == 0){
                res.data.data.list[i].purchasabled = "是";
              }else{
                res.data.data.list[i].purchasabled = "否";
              }
            }
            if(res.data.data.list[i].logo){
              res.data.data.list[i].logo2 = res.data.data.list[i].logo;
            }
            if(res.data.data.list[i].price){
              res.data.data.list[i].price = parseFloat(res.data.data.list[i].price);
              res.data.data.list[i].price2 = (res.data.data.list[i].price).toLocaleString();
            }
          }
          _this.proList = res.data.data.list;
          if(_this.proList.length>0 && _this.proList2.length>0){
            _this.logoNamePush(_this.proList,_this.proList2);
          }
          
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.listLoading = false;
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.listLoading = false;
      });
    },
    //读取cookie
    getCookie: function() {
      if (document.cookie.length > 0) {
          var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
          for (var i = 0; i < arr.length; i++) {
              var arr2 = arr[i].split('='); //再次切割
              //判断查找相对应的值
              if (arr2[0] == 'dnnyptadmin_token') {
                  this.token = arr2[1]; //保存到保存数据的地方
              } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                  this.checkCode = arr2[1];
              } else if (arr2[0] == 'dnnyptadmin_id') {
                  this.id = arr2[1];
              }
          }
      }
    },
    getUser:function(ide){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        id:ide,
      }
      API_User.getUserDetail(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.checkUser = '';
          if(res.data.data.name){
            this.checkUser = res.data.data.name;
          }
          if(res.data.data.phone){
            this.checkUser = this.checkUser + ' '+ res.data.data.phone;
          }
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    getDetail:function(){
      let _this = this;
      // let myId = this.$route.params.id;
      let myId = this.$route.query.id;
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        id:myId,
      }
      API_Order.detailOrder(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          _this.proList2 = JSON.parse(res.data.data.product);
          if(_this.proList2.length>0 && _this.proList.length>0){
            _this.logoNamePush(_this.proList,_this.proList2);
          }
          _this.allPrice = res.data.data.price;
          if(_this.allPrice){
            _this.allPrice = parseFloat(_this.allPrice);
            _this.allPrice = (_this.allPrice).toLocaleString();
          }
          if(res.data.data.companyid){
            _this.person = '2';
            _this.userType = '企业用户';
            _this.checkPerson = this.$route.query.name;
          }else{
            _this.person = '1';
            _this.userType = '个人用户';
            _this.checkUserId = res.data.data.userid;
            _this.getUser(res.data.data.userid);
          }
          _this.getProList();
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    },
    logoNamePush:function(proList,proList2){
      console.log(proList);
      console.log(proList2);
      this.ygPrice = 0;
      for(var i=0;i<proList2.length;i++){
        for(var k=0;k<proList.length;k++){
          if(proList2[i].productId == proList[k].id){
            console.log(222);
            this.proList2[i].logo2 = proList[k].logo2;
            this.proList2[i].name = proList[k].name;
            this.proList2[i].price = proList[k].price;
            if(this.proList2[i].price){
              this.proList2[i].price = parseFloat(this.proList2[i].price);
              this.proList2[i].price2 = (this.proList2[i].price).toLocaleString();
            }
          }
        }
        // this.ygPrice = this.ygPrice + this.proList2[i].purchaseNum*this.proList2[i].purchaseMonth*this.proList2[i].singlePrice;  
        this.ygPrice = this.ygPrice + this.proList2[i].purchaseNum*this.proList2[i].purchaseMonth*this.proList2[i].price;  
      }
      if(this.ygPrice){
        this.ygPrice = parseFloat(this.ygPrice);
        this.ygPrice = (this.ygPrice).toLocaleString();
      }
      this.proList3 = this.proList2;
    },
    bak:function(){
      this.$router.push({
        path: '/orderList',
        query: {
          dynamicTags:this.$route.query.dynamicTags,
          souchs:this.$route.query.souchs,
          type:1,
          pageNumber:this.$route.query.pageNumber
        }
      });
      //this.$router.go(-1);
    },
  },
  mounted(){
    // this.getUser();
  },
  created(){
    this.getCookie();
    this.getDetail();
  },
  beforeMount(){
    // this.getProList();
    
  }

}
</script>
<style >
.aaaaa .el-table__body-wrapper{
  height:450px;
  overflow-y: auto;
}
.price .el-input__inner{
  height:30px;
}
.order-checkbox{
  position: relative;
  right: 30px;
  float: right;
}
.allPrice{
  float: right;
  position: relative;
  left: 65px; 
  padding-top: 10px;
}
.ygPrice{
  width:200px;
  float: right;
  position: relative;
  left: 65px; 
  padding-top: 10px;
}
.order-sub{
  padding-top: 35px;
  float: right;
  position: relative;
  left: 449px;
}
.orderSubmit{
  height:30px;
  padding: 7px 15px;
}
</style>



// WEBPACK FOOTER //
// OrderEdit.vue?246a1a60